import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { responsive } from "../../utils/style";
import MILK_HERO from "../../assets/images/milk_hero_rewards.svg";
import VEGGIE_HERO from "../../assets/images/veggie_hero_rewards.svg";
import MOVE_HERO from "../../assets/images/move_hero_rewards.svg";
import DRINK_HERO from "../../assets/images/drink_hero_rewards.svg";
import SUPER_HEALTH_HERO from "../../assets/images/super_health_hero_rewards.svg";
import MARVEL_HEALTH_HERO from "../../assets/images/marvel_health_hero_rewards.svg";

const DATA = [
  {
    topic: "เป้าหมายที่ 1 เหรียญมิลค์ฮีโร่ (Milk Hero)",
    info: "มี 4 ระดับ คือ ทองแดง เงิน ทอง และ แพลทินัม",
    image: MILK_HERO,
  },
  {
    topic: "เป้าหมายที่ 2 เหรียญเวจจี้ฮีโร่ (Veggie Hero)",
    info: "มี 4 ระดับ คือ ทองแดง เงิน ทอง และ แพลทินัม",
    image: VEGGIE_HERO,
  },
  {
    topic: "เป้าหมายที่ 3 เหรียญมูฟฮีโร่ (Move Hero)",
    info: "มี 4 ระดับ คือ ทองแดง เงิน ทอง และ แพลทินัม",
    image: MOVE_HERO,
  },
  {
    topic: "เป้าหมายที่ 4 เหรียญดริ๊งค์ฮีโร่ (Drink Hero)",
    info: "มี 4 ระดับ คือ ทองแดง เงิน ทอง และ แพลทินัม",
    image: DRINK_HERO,
  },
  {
    topic: "รวม 4 เป้าหมาย ดาวซุปเปอร์เฮลท์ฮีโร่ <br /> (Super Health Hero)",
    info: "มี 4 ระดับ คือ ทองแดง เงิน ทอง และ แพลทินัม",
    image: SUPER_HEALTH_HERO,
  },
  {
    topic: "รวม 4 เป้าหมาย ถ้วยมาร์เวลเฮลท์ฮีโร่ <br /> (Marvel Health Hero)",
    info: "มี 1 ระดับ ระดับโรงเรียน",
    image: MARVEL_HEALTH_HERO,
  },
];

const Reward = () => {
  return (
    <Container>
      <Background>
        <Topic>ระดับรางวัล</Topic>
        <Section>
          <SubTopic>1. ลักษณะรางวัล</SubTopic>
          <List>
            มอบเป็นเหรียญ ดาวและถ้วยรางวัลแบบเป็นไฟล์รูปภาพ โดยเข้าดูได้ที่เมนู
            ขอทราบผล
          </List>
          <List>
            เหรียญ ดาว และถ้วยรางวัล คำนวนตามคะแนนสะสม Top 5 Ranking
            ที่ได้ในแต่ละช่วงและตลอดเกมการแข่งขันซึ่งสามารถนำไปแชร์ใน Facebook
            หรือสื่อโซเชียลได้
          </List>
        </Section>
        <Section>
          <SubTopic>2. ช่วงเวลาการจัด Ranking เพื่อให้รางวัล</SubTopic>
          ขึ้นกับระยะเวลาของเกมที่หัวหน้าโค้ชกำหนดไว้ เป็น 4 หรือ 8 หรือ 12 หรือ
          16 สัปดาห์ การคิดคะแนนมีทั้งแบบแยกช่วง ช่วงละ 2 สัปดาห์ และแบบ
          รวมตลอดเกมการแข่งขัน คือ
          <List>
            ช่วงที่ 1 คือ วันสุดท้ายของสัปดาห์ที่ 2 (คะแนนของช่วงที่ 1
            จะเป็นคะแนนของสัปดาห์ที่ 1-2 รวมเป็น 2 สัปดาห์)
          </List>
          <List>
            ช่วงที่ 2 คือ วันสุดท้ายของสัปดาห์ที่ 4 (ถ้าเกมยังไม่จบ
            คะแนนของช่วงที่ 2 จะแยกเฉพาะคะแนนของสัปดาห์ที่ 3-4 รวมเป็น 2 สัปดาห์
            แต่ถ้าเกมจบ 4 สัปดาห์ จะรวมคะแนนตลอดสัปดาห์ที่ 1-4 รวมเป็น 4
            สัปดาห์)
          </List>
          <List>
            ช่วงที่ 3 คือ วันสุดท้ายของสัปดาห์ที่ 6 (คะแนนของช่วงที่ 3
            จะแยกเฉพาะคะแนนของสัปดาห์ที่ 5-6 รวมเป็น 2 สัปดาห์)
          </List>
          <List>
            ช่วงที่ 4 คือ วันสุดท้ายของสัปดาห์ที่ 8 (ถ้าเกมยังไม่จบ
            คะแนนของช่วงที่ 4 จะแยกเฉพาะคะแนนของสัปดาห์ที่ 7-8 รวมเป็น 2 สัปดาห์
            แต่ถ้าเกมจบ 8 สัปดาห์ จะรวมตลอดสัปดาห์ที่ 1-8 รวมเป็น 8 สัปดาห์)
          </List>
          <List>
            ช่วงที่ 5 คือ วันสุดท้ายของสัปดาห์ที่ 10 (คะแนนของช่วงที่ 5
            จะแยกเฉพาะคะแนนของสัปดาห์ที่ 9-10 รวมเป็น 2 สัปดาห์)
          </List>
          <List>
            ช่วงที่ 6 คือ วันสุดท้ายของสัปดาห์ที่ 12 (ถ้าเกมยังไม่จบ
            คะแนนของช่วงที่ 6 จะแยกเฉพาะคะแนนของสัปดาห์ที่ 11-12 รวมเป็น 2
            สัปดาห์ แต่ถ้าเกมจบ จะเป็นคะแนน รวมของสัปดาห์ที่ 1-12 รวมเป็น 12
            สัปดาห์)
          </List>
          <List>
            ช่วงที่ 7 คือ วันสุดท้ายของสัปดาห์ที่ 14 (คะแนนของช่วงที่ 7
            จะแยกเฉพาะคะแนนของสัปดาห์ที่ 13-14 รวมเป็น 2 สัปดาห์)
          </List>
          <List>
            ช่วงที่ 8 คือ วันสุดท้ายของสัปดาห์ที่ 16 (คะแนนของช่วงที่ 8
            จะเป็นคะแนน รวมของสัปดาห์ที่ 1-16 รวมเป็น 16 สัปดาห์)
          </List>
        </Section>
        <Section>
          <SubTopic>3. ระดับคะแนนที่จะได้รางวัล</SubTopic>
          การจัด Ranking ทำโดยนำเฉพาะคะแนนรวมสะสมของแต่ละเป้าหมาย
          และคะแนนรวมสะสมของทั้ง 4 เป้าหมายของทุกคนในห้องในชั้นหรือใน โรงเรียนมา
          rank กัน คนที่จะได้รางวัล จะต้องมีคะแนนสะสมในแต่ละช่วง
          <List>
            ไม่ต่ำกว่า 80% ของคะแนนเต็มในแต่ละเป้าหมายหรือ 80% ของคะแนนรวม 4
            เป้าหมาย
          </List>
          <List>
            ติดอันดับ Top 5 Ranking ของห้องหรือชั้นเรียนหรือโรงเรียนแล้วแต่กรณี
          </List>
        </Section>
        <Section>
          <SubTopic> 4. รางวัลแยกตามเป้าหมายและรวม 4 เป้าหมาย</SubTopic>
          แต่ละเหรียญฮีโร่ (รางวัลแยกเป้าหมาย เหรียญ Milk Hero, เหรียญ Veggie
          Hero, เหรียญ Move Hero, เหรียญ Drink Hero) และดาวซูเปอร์เฮลท์ฮีโร่
          (รางวัลรวม 4 เป้าหมาย) จะมี 4 ระดับ คือ
          <List>
            <b>ทองแดง</b> (ระดับห้อง ทำได้ระยะเวลาเป็นช่วง 2 สัปดาห์) สัปดาห์ที่
            1- 2, 3-4, 5-6, 7-8,9-10,11-12,13-14
          </List>
          <List>
            <b>เงิน</b> (ระดับชั้น ทำได้ระยะเวลาเป็นช่วง 2 สัปดาห์) สัปดาห์ที่
            1- 2, 3-4, 5-6, 7-8, 9-10,11-12,13-14
          </List>
          <List>
            <b>ทอง</b> (ระดับห้องทำได้ระยะเวลาตลอดช่วงของการแข่งขัน)
          </List>
          <List>
            <b>แพลทินัม</b> (ระดับชั้นทำได้ระยะเวลาตลอดช่วงของการแข่งขัน){" "}
          </List>
          <List>
            <b>ถ้วย Marvel Health Hero</b> ระดับคะแนนนำมาRanking ทั้งโรงเรียน
            ใช้คะแนนสะสมรวมทุกเป้าหมายครั้งเดียวในวันสุดท้ายของเกม คือสัปดาห์ที่
            8, 12, 16 ตามระยะเวลาของเกมที่หัวหน้าโค้ชกำหนดไว้ (ที่ระยะ 4
            สัปดาห์ไม่มีถ้วยรางวัลนี้)
          </List>
          <GoalWrapper>
            {DATA.map((d, i) => (
              <GoalSection key={i}>
                <GoalTopic dangerouslySetInnerHTML={{ __html: d.topic }} />
                <GoalInfo>{d.info}</GoalInfo>
                <GoalImage src={d.image}></GoalImage>
              </GoalSection>
            ))}
          </GoalWrapper>
        </Section>
      </Background>
    </Container>
  );
};

export default Reward;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;
  width: 100%;
`;
const Background = styled.div`
  width: 100%;
  max-width: 1144px;
  background-color: white;
  padding: 40px 116px;
  margin: auto;

  ${responsive.tablet(css`
    padding: 40px 32px;
    max-width: unset;
  `)}

  ${responsive.mobile(css`
    padding: 24px 16px;
  `)}
`;
const Topic = styled.h4`
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #058459;
  margin-bottom: 24px;

  ${responsive.mobile(css`
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 18px;
  `)}
`;
const Section = styled.div`
  margin-bottom: 16px;
`;
const SubTopic = styled.h5`
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #4b5768;

  ${responsive.mobile(css`
    font-size: 16px;
  `)}
`;
const List = styled.li`
  text-indent: 10px;
`;
const GoalWrapper = styled.div`
  max-width: 660px;
  margin: auto;
  margin-top: 12px;
`;
const GoalSection = styled.div`
  margin-bottom: 16px;
`;
const GoalTopic = styled.label`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #4b5768;
  display: block;

  ${responsive.mobile(css`
    line-height: 26px;
    font-size: 16px;
  `)}
`;
const GoalInfo = styled(GoalTopic)`
  font-weight: 400;
`;
const GoalImage = styled.img`
  max-width: 660px;

  ${responsive.mobile(css`
    width: 100%;
  `)}
`;
const SubTopic2 = styled(SubTopic)`
  margin-bottom: 0px;
  margin-top: 5px;
`;
